import { Component, DestroyRef, inject, Input, OnInit, ViewChild } from '@angular/core';
import { translate } from '@jsverse/transloco';
import { CloudProvider } from 'src/app/models/cloud-provider/cloud-provider';
import { InventoryService } from 'src/app/services/api/inventory.service';
import { TenantService } from 'src/app/services/api/tenant.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { KubernetesResource } from 'src/app/models/kubernetes-resource';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
import { ColumnFilterComponent } from '../../instances-mgmt/column-filter/column-filter.component';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { ErrorDialogComponent } from 'src/app/components/error-dialog/error-dialog.component';
import { ConfirmationDialogComponent } from 'src/app/components/confirmation-dialog/confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { CapitalizeFirstPipe } from 'src/app/pipes/capitalize-first.pipe';
import { CloudResourcesInventoryComponent } from 'src/app/components/instance-details/cloud-resources-inventory/cloud-resources-inventory.component';
import { InventoryKubernetesComponent } from 'src/app/components/inventory-kubernetes/inventory-kubernetes.component';
import { DeployStatus } from 'src/app/models/deploy/deploy-status';
import { EnvironmentTableComponent } from '../environment-table/environment-table.component';
import { EnvironmentPaginatorComponent } from '../environment-paginator/environment-paginator.component';

@Component({
  selector: 'app-environment-inventory',
  templateUrl: './environment-inventory.component.html',
  styleUrl: './environment-inventory.component.scss',
  providers: [CapitalizeFirstPipe],
  standalone: false,
})
export class EnvironmentInventoryComponent implements OnInit {
  private destroyRef = inject(DestroyRef);
  @ViewChild(EnvironmentTableComponent) tableRef: EnvironmentTableComponent;
  @ViewChild(EnvironmentPaginatorComponent)
  paginatorRef: EnvironmentPaginatorComponent;
  @Input() instanceId;
  @Input() instance;
  @Input() isExternalTenant: boolean = true;

  tenantId: any;
  isAWS: boolean;
  showLoader = false;
  clearData: boolean;
  showSpinner: boolean;
  filteredColumns: any;
  products: boolean;
  inventoryProductsData: any;
  searchProductTerm: any;
  inventoryProducts: any;
  inventoryProdDropdown: any;
  prodVersionOptions: any;
  prodIsManagedOptions: any;
  selectedProdVersion: any[];
  productVersions: any;
  prodIsManaged: any;
  filteredProdColumns: any;
  filteredIsManagedColumns: any;
  isProdFilterResultEmpty = false;
  searchedProductsRes: any;
  selectedIsManaged: any;
  selectedVersion: any[];
  inventoryProductColumns = [
    {
      key: 'name',
      name: 'INSTANCE_DETAILS.NAME',
      type: 'text',
      sortable: true,
      visible: true,
      disable: true,
    },
    {
      key: 'version',
      name: 'INSTANCE_DETAILS.VERSION',
      type: 'text',
      sortable: true,
      visible: true,
      disable: true,
    },
    {
      key: 'image',
      name: 'INSTANCE_DETAILS.IMAGE',
      type: 'text',
      sortable: true,
      visible: true,
      disable: false,
    },
    {
      key: 'workload',
      name: 'INSTANCE_DETAILS.WORK_LOAD',
      type: 'text',
      sortable: true,
      visible: false,
      disable: false,
    },
    {
      key: 'isManaged',
      name: 'INSTANCE_DETAILS.IS_MANAGED',
      type: 'text',
      sortable: true,
      visible: false,
      disable: false,
    },
    {
      key: 'InventoryProductSettings',
      name: '',
      type: 'settings',
      visible: true,
      disable: true,
    },
  ];
  components: boolean;
  inventoryData: any;
  inventoryComponentData: any;
  inventoryComponents: any;
  searchInventoryTerm: string;
  inventoryLoading = true;
  searchedComponentResult = [];
  componentStatus: any;
  selectedStatus = [];
  ComponentFilter: any;
  componentFilterOptions: any;
  inventoryComponentColumns = [
    {
      key: 'name',
      name: 'INSTANCE_DETAILS.NAME',
      type: 'text',
      sortable: true,
      visible: true,
      disable: true,
    },
    {
      key: 'version',
      name: 'INSTANCE_DETAILS.VERSION',
      type: 'text',
      sortable: true,
      visible: true,
      disable: true,
    },
    {
      key: 'status',
      name: 'INSTANCE_DETAILS.STATUS',
      type: 'status',
      sortable: true,
      visible: true,
      disable: false,
    },
  ];
  cloud: boolean;
  cloudResourceData: any;
  searchTerm: string;
  cloudResourceLoader = true;
  initialCloudResourceData: any;
  searchedResult: any;
  InventoryCloudDropdownList: any;
  typeOptions: any;
  types: any;
  selectedType: any[];
  status: any;
  inventoryColumns = [
    {
      key: 'name',
      name: 'TENANT_DETAILS.CLOUD_NAME',
      type: 'text',
      sortable: true,
      visible: true,
      disable: true,
    },
    {
      key: 'type',
      name: 'TENANT_DETAILS.CLOUD_TYPE',
      type: 'text',
      sortable: true,
      visible: true,
      disable: false,
    },
    {
      key: 'kind',
      name: 'TENANT_DETAILS.CLOUD_KIND',
      type: 'text',
      sortable: true,
      visible: true,
      disable: false,
    },
    {
      key: 'skuData',
      name: 'TENANT_DETAILS.CLOUD_SKU',
      type: 'text',
      sortable: true,
      visible: true,
      disable: false,
    },
    {
      key: 'cloudInventorySettings',
      name: '',
      type: 'settings',
      visible: true,
      disable: true,
    },
  ];
  kubernetes: boolean;
  inventoryKubernetesData: any;
  inventoryKubernetes: any;
  searchedKubernetesRes: any;
  searchKubTerm: any;
  kubernetesName: any;
  inventoryKubernetesColumns = [
    {
      key: 'name',
      name: 'TENANT_DETAILS.NAME_SPACE',
      type: 'text',
      sortable: true,
      visible: true,
      disable: true,
    },
    {
      key: 'details',
      name: '',
      type: 'descriptionIcon',
      visible: true,
      disable: false,
    },
  ];
  pageIndex = 0;
  paginationSize = 10;
  readonly EXCECUTETEST_ENABLE_STATES = [
    DeployStatus.DEPLOYED,
    DeployStatus.UPDATED,
    DeployStatus.UPDATE_FAILED,
    DeployStatus.CONFIGURED,
    DeployStatus.CONFIGURATION_FAILED,
    DeployStatus.TESTED,
    DeployStatus.FAILOVER_FAILED,
    DeployStatus.FAILBACK_FAILED,
    DeployStatus.PRE_FAILBACK_FAILED,
    DeployStatus.POST_FAILBACK_FAILED,
    DeployStatus.STOP_FAILED,
  ];

  constructor(
    private tenantService: TenantService,
    public inventoryService: InventoryService,
    private toastrService: CustomToastrService,
    private sidenavService: SidenavService,
    private dialog: MatDialog,
    private capitalizeFirst: CapitalizeFirstPipe
  ) {}

  ngOnInit(): void {
    this.tenantService.tenantData$.subscribe((data: any) => {
      this.isAWS = data === CloudProvider.AWS ? true : false;
    });
    if (!this.isAWS) {
      this.componentFilterOptions = [
        { value: 'Success', selected: false, label: 'Success' },
        { value: 'Failed', selected: false, label: 'Failed' },
      ];
      this.ComponentFilter = [
        {
          title: 'Status',
          placeholder: 'Select Status',
          options: this.componentFilterOptions,
        },
      ];
      if (localStorage.getItem('filteredComponentStatus')) {
        this.componentStatus = JSON.parse(
          localStorage.getItem('filteredComponentStatus')
        );
        if (this.componentStatus) {
          this.selectedStatus = this.componentStatus;
          this.componentStatus = this.selectedStatus;
          this.ComponentFilter[0]?.options.forEach((element) => {
            if (this.selectedStatus.find((item) => item === element.value)) {
              element.selected = true;
            }
          });
        }
      }
      this.getInventoryDetails();
    }
  }

  // fetch instace's inventory details
  getInventoryDetails(): void {
    this.searchInventoryTerm = '';
    this.searchKubTerm = '';
    this.searchTerm = '';
    this.searchProductTerm = '';
    this.showLoader = true;
    this.inventoryService
      .getInventoryByInstance(this.instanceId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(
        (result) => {
          const data = result?.inventories ? result.inventories[0] : undefined;
          if (data && data.discoveryTable?.rows?.length > 0) {
            this.inventoryComponentData = data?.discoveryTable?.rows.map(
              (obj) => ({ ...obj, name: obj.component })
            );
            this.inventoryComponents = this.inventoryComponentData;
          }
          if (this.componentStatus?.length) {
            this.inventoryComponents = this.inventoryComponentData?.filter(
              (item) => this.selectedStatus?.includes(item?.status)
            );
          }
          if (data && data.compute?.length > 0) {
            // Kubernetes model to restructure the json
            this.kubernetesName = data.compute[0]?.name;
            if (data.compute[0]?.resources.length > 0) {
              this.inventoryKubernetesData =
                KubernetesResource.transformResourcesAllNamespaces(
                  data.compute[0]?.resources
                );
              this.inventoryKubernetes = this.inventoryKubernetesData;
            }
          }
          if (data && data.products?.length > 0) {
            this.inventoryProductsData = data?.products?.map((obj) => ({
              ...obj,
              name: obj.product,
              isManaged: obj.isManaged === 'true' ? 'Yes' : 'No',
            }));
            this.inventoryProducts = this.inventoryProductsData;
          }
          this.inventoryLoading = false;
          this.showLoader = false;
          this.cloudResourceData = data?.infra?.resources;
          this.initialCloudResourceData = data?.infra?.resources;
          this.cloudResourceLoader = false;
          this.cloudResourceData?.forEach((item) => {
            item.skuData = item?.sku?.name ? item?.sku?.name : '-';
          });
          this.handleInventoryProductData();
          const types = this.cloudResourceData?.map((item) => item.type);
          const uniqueArray = [...new Set(types)];
          const outputArray = this.transformArray(uniqueArray);
          this.typeOptions = outputArray;
          this.InventoryCloudDropdownList = [
            {
              title: 'Type',
              placeholder: 'Select Type',
              options: this.typeOptions,
            },
          ];
          if (localStorage.getItem('inventoryCloudFiltered')) {
            const filteredColumns = JSON.parse(
              localStorage.getItem('inventoryCloudFiltered')
            );
            this.filteredColumns = [filteredColumns];
            if (filteredColumns) {
              this.selectedType = filteredColumns;
              this.status = this.selectedType;
              this.InventoryCloudDropdownList[0].options.forEach((element) => {
                if (this.selectedType.find((item) => item === element.value)) {
                  element.selected = true;
                }
              });
            }
          }
          this.initialProductFilterItems();
          this.initialFilterItems();
        },
        (error) => {
          this.showSpinner = false;
          this.cloudResourceLoader = false;
          this.inventoryLoading = false;
          this.showLoader = false;
          setTimeout(() => {
            const title = translate('ERRORS.SERVICE_AVAILABILITY');
            const message = error?.message
              ? error?.message
              : error?.error?.message
              ? error?.error?.message
              : error?.errmsg
              ? error?.errmsg
              : translate('SERVICE.INTERNAL_SERVER_ERROR');
            this.toastrService.errMessage(message, title);
          }, 500);
        }
      );
  }
  handleInventoryProductData() {
    const versions = this.inventoryProductsData?.map((item) => item.version);
    const versionsArray = [...new Set(versions)];
    const outputVersionsArray: any = this.transformArray(versionsArray);
    this.prodVersionOptions = outputVersionsArray.sort((a, b) => {
      const aVal = parseInt(a.value.split('.')[0], 10);
      const bVal = parseInt(b.value.split('.')[0], 10);
      return aVal - bVal;
    });
    this.prodIsManagedOptions = [
      { value: 'Yes', label: 'Temenos', selected: false },
      { value: 'No', label: 'Third Party', selected: false },
    ];
    this.inventoryProdDropdown = [
      {
        title: 'Version',
        placeholder: 'Select Version',
        options: this.prodVersionOptions,
      },
      {
        title: 'Managed By',
        placeholder: 'Select Managed By',
        options: this.prodIsManagedOptions,
      },
    ];
    if (localStorage.getItem('prodVersionsFiltered')) {
      const filteredColumns = JSON.parse(
        localStorage.getItem('prodVersionsFiltered')
      );
      this.filteredProdColumns = [filteredColumns];
      if (filteredColumns) {
        this.selectedVersion = filteredColumns;
        this.productVersions = this.selectedVersion;
        this.inventoryProdDropdown[0].options.forEach((element) => {
          if (this.selectedVersion.find((item) => item === element.value)) {
            element.selected = true;
          }
        });
      }
    }
    if (localStorage.getItem('prodIsManagedFiltered')) {
      const filteredColumns = JSON.parse(
        localStorage.getItem('prodIsManagedFiltered')
      );
      this.filteredIsManagedColumns = [filteredColumns];
      if (filteredColumns) {
        this.selectedIsManaged = filteredColumns;
        this.prodIsManaged = this.selectedIsManaged;
        this.inventoryProdDropdown[1].options.forEach((element) => {
          if (this.selectedIsManaged.find((item) => item === element.value)) {
            element.selected = true;
          }
        });
      }
    }
  }

  transformArray(arr): void {
    return arr.map((item) => ({
      value: item,
      label: item.charAt(0).toUpperCase() + item.slice(1),
      selected: false,
    }));
  }
  // onload - filtering product data
  initialProductFilterItems() {
    this.inventoryProductsData = this.inventoryProducts;
    if (this.selectedVersion?.length > 0) {
      this.inventoryProductsData = this.inventoryProductsData?.filter((item) =>
        this.selectedVersion?.includes(item?.version)
      );
    }
    if (this.selectedIsManaged?.length > 0) {
      this.inventoryProductsData = this.inventoryProductsData?.filter((item) =>
        this.selectedIsManaged?.includes(item?.isManaged)
      );
    }
    if (this.inventoryProductsData?.length == 0) {
      this.isProdFilterResultEmpty = true;
    } else {
      this.isProdFilterResultEmpty = false;
    }
  }
  // onload - filtering cloud data
  initialFilterItems() {
    this.cloudResourceData = this.initialCloudResourceData;
    if (this.selectedType?.length > 0) {
      this.cloudResourceData = this.cloudResourceData?.filter((item) =>
        this.selectedType?.includes(item?.type)
      );
    }
  }

  /**
   * function triggered while clicking on tabs
   * @param event
   */
  public inventoryTabs(event?): void {
    this.components = false;
    this.kubernetes = false;
    this.cloud = false;
    this.products = false;
    this.pageIndex = 0;
    this.paginationSize = 10;
    if (event === 'cloud') {
      this.cloud = true;
    } else if (event === 'components') {
      this.components = true;
    } else if (event === 'kubernetes') {
      this.kubernetes = true;
    } else if (event === 'products') {
      this.products = true;
    }
    this.getInventoryDetails();
  }
  // product - displaying filter component
  filterProductColumns(data): void {
    if (this.productVersions) {
      this.inventoryProdDropdown[0]?.options.filter((item) => {
        if (this.productVersions?.find((version) => version === item.value)) {
          item.selected = true;
        } else {
          item.selected = false;
        }
      });
    } else {
      this.inventoryProdDropdown[0]?.options.filter((item) => {
        item.selected = false;
      });
    }

    if (this.prodIsManaged) {
      this.inventoryProdDropdown[1]?.options.filter((item) => {
        if (this.prodIsManaged?.find((isManaged) => isManaged === item.value)) {
          item.selected = true;
        } else {
          item.selected = false;
        }
      });
    } else {
      this.inventoryProdDropdown[1]?.options.filter((item) => {
        item.selected = false;
      });
    }

    const data1 = {
      name: translate('INVENTORY.PROD_VERSION_FILTERS'),
      title: translate('INSTANCE_STATUS.FILTER_TITLE'),
      subtitle: translate('INSTANCE_STATUS.FILTER_SUBTITLE'),
      filteredColumns: this.inventoryProdDropdown,
      inventoryProdVersionList: this.inventoryProdDropdown[0].options,
      inventoryProdIsManagedList: this.inventoryProdDropdown[1].options,
      inventoryProductColumns: ['version', 'isManaged'],
    };
    this.sidenavService
      .openInRightSidenav(ColumnFilterComponent, data1)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((filteredColumns) => {
        this.filteredProdColumns = filteredColumns;
        if (filteredColumns) {
          this.clearData = true;
          if (filteredColumns[0] !== '') {
            this.productVersions = filteredColumns[0];
          }
          if (filteredColumns[1] !== '') {
            this.prodIsManaged = filteredColumns[1];
          }
          if (
            filteredColumns[0]?.length === 0 &&
            filteredColumns[1]?.length === 0
          ) {
            this.resetProductFilter();
          } else {
            this.filterProductItems(filteredColumns);
          }
        }
      });
  }
  filterProductItems(filteredColumns): void {
    if (filteredColumns) {
      this.inventoryProductsData = this.inventoryProducts;
      this.selectedVersion = [];
      this.selectedIsManaged = [];
      if (filteredColumns[0]?.length > 0) {
        this.selectedVersion = filteredColumns[0];
        if (filteredColumns[0].length > 0) {
          localStorage.setItem(
            'prodVersionsFiltered',
            JSON.stringify(this.selectedVersion)
          );
          this.inventoryProductsData = this.inventoryProductsData?.filter(
            (item) => this.selectedVersion?.includes(item?.version)
          );
        } else {
          localStorage.removeItem('prodVersionsFiltered');
        }
      }
      if (filteredColumns[1]?.length > 0) {
        this.selectedIsManaged = filteredColumns[1];
        if (filteredColumns[1].length > 0) {
          localStorage.setItem(
            'prodIsManagedFiltered',
            JSON.stringify(this.selectedIsManaged)
          );
          this.inventoryProductsData = this.inventoryProductsData?.filter(
            (item) => this.selectedIsManaged?.includes(item?.isManaged)
          );
        } else {
          localStorage.removeItem('prodIsManagedFiltered');
        }
      }
      if (this.inventoryProductsData.length == 0) {
        this.isProdFilterResultEmpty = true;
      } else {
        this.isProdFilterResultEmpty = false;
      }
    }
  }
  searchProducts(searchTerm?: string): void {
    this.searchProductTerm = searchTerm;
  }
  searchedProductItems(result): void {
    this.searchedProductsRes = result;
  }

  getProductVersions(version): void {
    return this.prodVersionOptions.find((item) => item.value === version).label;
  }

  getProductIsManaged(isMaanaged): void {
    return this.prodIsManagedOptions.find((item) => item.value === isMaanaged)
      .label;
  }

  // product - resetting applied version filter
  cancelVersionFilter(data) {
    let selectedItem = this.selectedVersion.indexOf(data);
    if (selectedItem > -1) {
      localStorage.removeItem('prodVersionsFiltered');
      this.selectedVersion.splice(selectedItem, 1);
      this.inventoryProdDropdown[0].options.find(
        (item) => item.value === data
      ).selected = false;
      localStorage.setItem(
        'prodVersionsFiltered',
        JSON.stringify(this.selectedVersion)
      );
      this.filterProductItems(this.filteredProdColumns);
    }
    if (
      this.selectedVersion.length === 0 &&
      this.selectedIsManaged.length === 0
    ) {
      this.inventoryProductsData = this.inventoryProducts;
    }
  }
  // product - resetting applied managed filter
  cancelIsManagedFilter(data) {
    let selectedItem = this.selectedIsManaged.indexOf(data);
    if (selectedItem > -1) {
      localStorage.removeItem('prodIsManagedFiltered');
      this.selectedIsManaged.splice(selectedItem, 1);
      this.inventoryProdDropdown[1].options.find(
        (item) => item.value === data
      ).selected = false;
      localStorage.setItem(
        'prodIsManagedFiltered',
        JSON.stringify(this.selectedIsManaged)
      );
      this.filterProductItems(this.filteredProdColumns);
    }
    if (
      this.selectedVersion.length === 0 &&
      this.selectedIsManaged.length === 0
    ) {
      this.inventoryProductsData = this.inventoryProducts;
    }
  }
  // product - resetting applied filter
  resetProductFilter() {
    this.selectedVersion = [];
    this.selectedIsManaged = [];
    this.sidenavService.searchFilter.next('data');
    this.inventoryProdDropdown[0].options.filter((item) => {
      item.selected = false;
    });
    this.inventoryProdDropdown[1].options.filter((item) => {
      item.selected = false;
    });
    this.productVersions = undefined;
    this.prodIsManaged = undefined;
    this.inventoryProductsData = this.inventoryProducts;
    localStorage.removeItem('prodVersionsFiltered');
    localStorage.removeItem('prodIsManagedFiltered');
  }

  // components - displaying filter component
  filterInventoryComponent() {
    if (this.componentStatus) {
      this.ComponentFilter[0].options.filter((item) => {
        if (item.value === this.status) {
          item.selected = true;
        }
      });
    } else {
      this.ComponentFilter[0].options.filter((item) => {
        item.selected = false;
      });
    }
    const data: any = {
      name: translate('TENANT_DETAILS.COMPONENTS'),
      title: translate('INSTANCE_STATUS.FILTER_TITLE'),
      subtitle: translate('INSTANCE_STATUS.FILTER_SUBTITLE'),
      isMultiSelect: false,
      filteredColumns: this.ComponentFilter,
      componentStatus: this.componentFilterOptions,
      componentColumn: ['status'],
    };
    this.sidenavService
      .openInRightSidenav(ColumnFilterComponent, data)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((filteredColumns) => {
        if (filteredColumns) {
          this.clearData = true;
          if (filteredColumns[0] !== '') {
            this.componentStatus = filteredColumns[0];
          }
          this.filterComponentItems(filteredColumns);
        }
      });
  }
  filterComponentItems(filteredColumns): void {
    this.inventoryComponents = this.inventoryComponentData;
    if (filteredColumns) {
      this.selectedStatus = [];
      if (filteredColumns[0]?.length > 0) {
        this.selectedStatus = filteredColumns[0];
        localStorage.setItem(
          'filteredComponentStatus',
          JSON.stringify(this.selectedStatus)
        );
        this.inventoryComponents = this.inventoryComponents?.filter((item) =>
          this.selectedStatus?.includes(item?.status)
        );
      } else {
        localStorage.removeItem('filteredComponentStatus');
      }
    }
  }

  getStatusLabel(status): void {
    return this.componentFilterOptions.find((item) => item.value === status)
      .label;
  }
  // components - resetting applied status filter
  cancelComponentFilter(data) {
    let selectedItem = this.selectedStatus.indexOf(data);
    if (selectedItem > -1) {
      localStorage.removeItem('filteredComponentStatus');
      this.selectedStatus.splice(selectedItem, 1);
      this.ComponentFilter[0].options.find(
        (item) => item.value === data
      ).selected = false;
      localStorage.setItem(
        'filteredComponentStatus',
        JSON.stringify(this.selectedStatus)
      );
      this.filterComponentItems(this.filteredColumns);
    }
    if (this.selectedStatus.length === 0) {
      this.inventoryComponents = this.inventoryComponentData;
    }
  }
  /**
   * Calls filter function when search term changes for components
   * @param - the search term entered
   */
  searchInventory(searchTerm?: string): void {
    this.searchInventoryTerm = searchTerm;
  }
  /**
   * Calls filter function when search term changes for components
   * @param - the search term entered
   */
  searchedComponentItems(result): void {
    this.searchedComponentResult = result;
  }
  // components - resetting applied filter
  resetComponentFilter(): void {
    this.selectedStatus = [];
    this.sidenavService.searchFilter.next('data');
    this.ComponentFilter[0].options.filter((item) => {
      item.selected = false;
    });
    this.componentStatus = undefined;
    this.inventoryComponents = this.inventoryComponentData;
    localStorage.removeItem('filteredComponentStatus');
  }

  // cloud - displaying filter component
  filterCloudColumns(data): void {
    this.InventoryCloudDropdownList[0]?.options.filter((item) => {
      if (this.types?.find((type) => type === item.value)) {
        item.selected = true;
      }
    });
    const data1 = {
      name: translate('INVENTORY.INVENTORY_FILTERS'),
      title: translate('INSTANCE_STATUS.FILTER_TITLE'),
      subtitle: translate('INSTANCE_STATUS.FILTER_SUBTITLE'),
      filteredColumns: this.InventoryCloudDropdownList,
      inventoryTypeList: this.InventoryCloudDropdownList[0].options,
      inventoryColumns: ['type'],
    };
    this.sidenavService
      .openInRightSidenav(ColumnFilterComponent, data1)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((filteredColumns) => {
        this.filteredColumns = filteredColumns;
        if (filteredColumns) {
          this.clearData = true;
          if (filteredColumns[0] !== '') {
            this.types = filteredColumns[0];
          }
          if (filteredColumns[0]?.length === 0) {
            this.resetInventoryFilter();
          } else {
            this.filterInventoryItems(filteredColumns);
          }
        }
      });
  }
  filterInventoryItems(filteredColumns): void {
    if (filteredColumns) {
      this.cloudResourceData = this.initialCloudResourceData;
      this.selectedType = [];
      if (filteredColumns[0]?.length > 0) {
        this.selectedType = filteredColumns[0];
        if (filteredColumns[0].length > 0) {
          localStorage.setItem(
            'inventoryCloudFiltered',
            JSON.stringify(this.selectedType)
          );
          this.cloudResourceData = this.cloudResourceData?.filter((item) =>
            this.selectedType?.includes(item?.type)
          );
        } else {
          localStorage.removeItem('inventoryCloudFiltered');
        }
      }
    }
  }
  // cloud - cancel applied type filter
  cancelTypeFilter(data) {
    let selectedItem = this.selectedType.indexOf(data);
    if (selectedItem > -1) {
      localStorage.removeItem('inventoryCloudFiltered');
      this.selectedType.splice(selectedItem, 1);
      this.InventoryCloudDropdownList[0].options.find(
        (item) => item.value === data
      ).selected = false;
      localStorage.setItem(
        'inventoryCloudFiltered',
        JSON.stringify(this.selectedType)
      );
      this.filterInventoryItems(this.filteredColumns);
    }
  }
  // cloud - resetting applied filter
  resetInventoryFilter(): void {
    this.selectedType = [];
    this.sidenavService.searchFilter.next('data');
    this.InventoryCloudDropdownList[0].options.filter((item) => {
      item.selected = false;
    });
    this.types = undefined;
    this.cloudResourceData = this.initialCloudResourceData;
    localStorage.removeItem('inventoryCloudFiltered');
  }
  getType(type): void {
    return this.typeOptions.find((item) => item.value === type).label;
  }

  /**
   * Calls filter function when search term changes for inventoryCloud
   * @param - the search term entered
   */
  searchCloud(searchTerm?: string): void {
    this.searchTerm = searchTerm;
  }
  /**
   * Calls filter function when search term changes for inventoryCloud
   * @param - the search term entered
   */
  searchedItems(result): void {
    this.searchedResult = result;
  }
  /**
   * cloud - This method calls when a user needs to view the resource by type .
   */
  viewInventoryCloud() {
    const dataInventory = {
      inventoryData: this.initialCloudResourceData,
      instanceName: this.instance?.name,
    };
    this.sidenavService.openInRightSidenav(
      CloudResourcesInventoryComponent,
      dataInventory
    );
  }
  /**
   * Calls filter function when search term changes for kubernetes
   * @param - the search term entered
   */
  searchKubernetes(searchTerm?: string): void {
    this.searchKubTerm = searchTerm;
  }
  /**
   * Calls filter function when search term changes for kubernetes
   * @param - the search term entered
   */
  searchedKubernetesItems(result): void {
    this.searchedKubernetesRes = result;
  }
  //
  viewKubernetesDetails(value): void {
    this.dialog
      .open(InventoryKubernetesComponent, {
        panelClass: 'default-dialog-wrapper',
        width: '1280px',
        autoFocus: false,
        data: {
          title: value.name,
          message: 'Name Space',
          records: value,
        },
      })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((response) => {
        if (response) {
        }
      });
  }
  // sync - send a request to refresh the inventory data from the Cloud
  syncInventoryCloud(): void {
    this.dialog
      .open(ConfirmationDialogComponent, {
        panelClass: 'default-dialog-wrapper',
        width: '566px',
        autoFocus: false,
        data: {
          title: translate('INVENTORY.SYNC'),
          message: translate('INVENTORY.SYNC_MESSAGE'),
          note: 'Note: This action will send a request to refresh the inventory data from the Cloud.The process typically completes within <b>2 to 3 minutes</b>. Please <b>refresh</b> the page <b>after 3 minutes</b> to see the updated data.',
          confirmButtonText: translate('DIALOG.CONFIRM'),
        },
      })
      .afterClosed()
      .subscribe({
        next: (confirm) => {
          if (confirm) {
            this.inventoryService
              .putInventoryByInstance(this.instanceId)
              .pipe(takeUntilDestroyed(this.destroyRef))
              .subscribe(
                (data) => {
                  this.getInventoryDetails();
                },
                (error) => {
                  this.showSpinner = false;
                  const errorMessage =
                    typeof error === 'string'
                      ? error
                      : typeof error?.error === 'string'
                      ? error.error
                      : error;
                  this.dialog.open(ErrorDialogComponent, {
                    minHeight: '280px',
                    width: '630px',
                    panelClass: 'flex-dialog',
                    data: {
                      title: translate('ERROR_DIALOG.SYNC_INVENTORY_FAILED'),
                      description: errorMessage,
                    },
                  });
                }
              );
          }
        },
      });
  }
  //download data in csv format
  downloadCSV(downloadType) {
    let csvContent = '';
    let filename = '';
    if (downloadType === 'products') {
      csvContent = 'NAME, VERSION, IMAGE\n';
      filename = 'Products.csv';
      this.inventoryProductsData.forEach((row) => {
        csvContent += `${this.capitalizeFirst.transform(row.name)},${
          row.version
        },${row.image}\n`;
      });
    } else if (downloadType === 'components') {
      csvContent = 'NAME, VERSION, STATUS\n';
      filename = 'Components.csv';
      this.inventoryComponentData.forEach((row) => {
        csvContent += `${this.capitalizeFirst.transform(row.component)},${
          row.version
        },${this.capitalizeFirst.transform(row.status)}\n`;
      });
    } else if (downloadType === 'cloudResources') {
      csvContent = 'NAME, TYPE, KIND, SKU\n';
      filename = 'Cloud Resources.csv';
      this.cloudResourceData.forEach((row) => {
        csvContent += `${this.capitalizeFirst.transform(
          row.name
        )},${this.capitalizeFirst.transform(
          row.type
        )},${this.capitalizeFirst.transform(
          row?.kind
        )},${this.capitalizeFirst.transform(row?.sku?.name)}\n`;
      });
    }

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    }
  }
  onPageChange(event) {
    this.paginationSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.tableRef?.pageChanged(event);
  }
  onTablePageChanged(event) {
    this.pageIndex = event.pageIndex;
    this.paginationSize = event.pageSize;
  }
  resetPaginator() {
    this.pageIndex = 0;
    this.paginatorRef.pageIndex = 0;
  }
}
